/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
import PropTypes from "prop-types";
import cns from "classnames";
import React from "react";
import {
  formInput,
  formLabel,
  validationError,
} from "@/assets/styles/common.module.scss";
import { REGEX } from "@/config/regex";

const LabelInputTxt = ({
  lblTxt,
  inputNm,
  parentClass = "",
  childClass = "",
  value,
  onChange,
  error = "",
  refreshErrors,
  // regexClass = /[A-Za-z0-9\s]/,
  regexClass = REGEX.ALPHANUMERIC_WITH_SPACES,
  size,
  ...restProps
}) => {
  function findDelta(value, prevValue) {
    let delta = "";

    for (let i = 0; i < value.length; i += 1) {
      const str =
        value.substr(0, i) + value.substr(i + value.length - prevValue.length);

      if (str === prevValue) {
        delta = value.substr(i, value.length - prevValue.length);
        return delta;
      }
    }
    return delta;
  }

  const isValidChar = (c) => regexClass.test(c);

  const isValidString = (str) => {
    for (const ch of str) if (!regexClass.test(ch)) return false;
    return true;
  };

  // only fired for printable Keys i.e. when content gets changed
  // doesn't work for arrow key, esc, enter, tab
  const handleInput = (e) => {
    const { value, selectionStart } = e.target;
    const lastVal = e.target.getAttribute("lastVal");

    // get inserted characters
    const inserted = findDelta(value, lastVal);
    // get removed characters
    const removed = findDelta(lastVal, value);
    // determine if user pasted content
    const pasted = inserted.length > 1 || (!inserted && !removed);

    if (pasted) {
      if (!isValidString(value) || (size && value.length > size)) {
        e.target.value = lastVal;
        e.target.selectionEnd = selectionStart - inserted.length;
      }
    } else if (!removed) {
      if (!isValidChar(inserted) || (size && value.length > size)) {
        e.target.value = lastVal;
        e.target.selectionEnd = selectionStart - inserted.length;
      }
    }

    e.target.setAttribute("lastVal", e.target.value);
  };

  const handleFocus = (e) => {
    e.target.setAttribute("lastVal", e.target.value);
  };

  const handleBlur = () => {
    refreshErrors(inputNm);
  };

  return (
    <section
      className={`d-flex flex-column flex-column-reverse ${parentClass}`}
    >
      <aside className={cns(formLabel, validationError)}>
        {error || ""}&nbsp;
      </aside>
      <input
        className={cns(formInput, "rounded-pill", childClass)}
        type="text"
        name={inputNm}
        id={inputNm}
        autoComplete="none"
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        onInput={handleInput}
        onFocus={handleFocus}
        size={size}
        {...restProps}
      />
      <label htmlFor={inputNm} className={cns("d-block", formLabel)}>
        {lblTxt}
      </label>
    </section>
  );
};

LabelInputTxt.propTypes = {
  childClass: PropTypes.string,
  error: PropTypes.string,
  inputNm: PropTypes.any,
  lblTxt: PropTypes.any,
  onChange: PropTypes.any,
  parentClass: PropTypes.string,
  refreshErrors: PropTypes.func,
  regexClass: PropTypes.string,
  size: PropTypes.any,
  value: PropTypes.shape({
    length: PropTypes.any,
    substr: PropTypes.func,
  }),
};

// when false => component will rerender
// when true => component will not update
// !shouldComponentUpdate
function arePropsEqual(prevProp, nextProp) {
  return (
    prevProp.value === nextProp.value &&
    prevProp.onChange === nextProp.onChange &&
    prevProp.error === nextProp.error
  );
}

export default React.memo(LabelInputTxt, arePropsEqual);
